var _rect, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatBot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 107,
    viewBox: "0 0 103 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 1,
    width: 78,
    height: 78,
    rx: 39,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_148_13775)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_148_13775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 43.2818C23 41.9088 24.1131 40.7957 25.4862 40.7957C26.8593 40.7957 27.9724 41.9088 27.9724 43.2818V50.1879C27.9724 51.561 26.8593 52.6741 25.4862 52.6741C24.1131 52.6741 23 51.561 23 50.1879V43.2818Z",
    fill: "#9BA1FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_148_13775)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8674 50.1879V43.2818C26.8674 42.519 26.249 41.9006 25.4862 41.9006C24.7234 41.9006 24.105 42.519 24.105 43.2818V50.1879C24.105 50.9507 24.7234 51.5691 25.4862 51.5691C26.249 51.5691 26.8674 50.9507 26.8674 50.1879ZM25.4862 40.7957C24.1131 40.7957 23 41.9088 23 43.2818V50.1879C23 51.561 24.1131 52.6741 25.4862 52.6741C26.8593 52.6741 27.9724 51.561 27.9724 50.1879V43.2818C27.9724 41.9088 26.8593 40.7957 25.4862 40.7957Z",
    fill: "#2E61D6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.0283 43.2818C68.0283 41.9088 69.1414 40.7957 70.5145 40.7957C71.8876 40.7957 73.0007 41.9088 73.0007 43.2818V50.1879C73.0007 51.561 71.8876 52.6741 70.5145 52.6741C69.1414 52.6741 68.0283 51.561 68.0283 50.1879V43.2818Z",
    fill: "#9BA1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8957 50.1879V43.2818C71.8957 42.519 71.2773 41.9006 70.5145 41.9006C69.7517 41.9006 69.1333 42.519 69.1333 43.2818V50.1879C69.1333 50.9507 69.7517 51.5691 70.5145 51.5691C71.2773 51.5691 71.8957 50.9507 71.8957 50.1879ZM70.5145 40.7957C69.1414 40.7957 68.0283 41.9088 68.0283 43.2818V50.1879C68.0283 51.561 69.1414 52.6741 70.5145 52.6741C71.8876 52.6741 73.0007 51.561 73.0007 50.1879V43.2818C73.0007 41.9088 71.8876 40.7957 70.5145 40.7957Z",
    fill: "#2E61D6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5845 31.6795L47.5845 22.011L48.6895 22.011L48.6895 31.6795L47.5845 31.6795Z",
    fill: "#2E61D6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_148_13775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.0596 30.5746C42.0596 28.5912 43.6674 26.9834 45.6507 26.9834H50.6231C52.6065 26.9834 54.2143 28.5912 54.2143 30.5746C54.2143 32.5579 52.6065 34.1657 50.6231 34.1657H45.6507C43.6674 34.1657 42.0596 32.5579 42.0596 30.5746Z",
    fill: "#2E61D6"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_148_13775)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6231 28.0884H45.6507C44.2776 28.0884 43.1645 29.2015 43.1645 30.5746C43.1645 31.9476 44.2776 33.0607 45.6507 33.0607H50.6231C51.9962 33.0607 53.1093 31.9476 53.1093 30.5746C53.1093 29.2015 51.9962 28.0884 50.6231 28.0884ZM45.6507 26.9834C43.6674 26.9834 42.0596 28.5912 42.0596 30.5746C42.0596 32.5579 43.6674 34.1657 45.6507 34.1657H50.6231C52.6065 34.1657 54.2143 32.5579 54.2143 30.5746C54.2143 28.5912 52.6065 26.9834 50.6231 26.9834H45.6507Z",
    fill: "#2E61D6"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_148_13775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.5576 18.4199C52.5576 20.8609 50.5787 22.8398 48.1377 22.8398C45.6966 22.8398 43.7178 20.8609 43.7178 18.4199C43.7178 15.9789 45.6966 14 48.1377 14C50.5787 14 52.5576 15.9789 52.5576 18.4199Z",
    fill: "#2E61D6"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_148_13775)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1377 21.7348C49.9684 21.7348 51.4526 20.2507 51.4526 18.4199C51.4526 16.5891 49.9684 15.105 48.1377 15.105C46.3069 15.105 44.8227 16.5891 44.8227 18.4199C44.8227 20.2507 46.3069 21.7348 48.1377 21.7348ZM48.1377 22.8398C50.5787 22.8398 52.5576 20.8609 52.5576 18.4199C52.5576 15.9789 50.5787 14 48.1377 14C45.6966 14 43.7178 15.9789 43.7178 18.4199C43.7178 20.8609 45.6966 22.8398 48.1377 22.8398Z",
    fill: "#2E61D6"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_148_13775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4863 46.0442C25.4863 37.6531 32.2886 30.8508 40.6797 30.8508H55.3206C63.7117 30.8508 70.514 37.6531 70.514 46.0442V53.2265C70.514 57.3458 67.1747 60.6851 63.0554 60.6851H32.9449C28.8256 60.6851 25.4863 57.3458 25.4863 53.2265V46.0442Z",
    fill: "#9BA1FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.5463 41.3481C44.5463 44.7045 41.8254 47.4255 38.469 47.4255C35.1125 47.4255 32.3916 44.7045 32.3916 41.3481C32.3916 37.9917 35.1125 35.2708 38.469 35.2708C41.8254 35.2708 44.5463 37.9917 44.5463 41.3481Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.469 46.3205C41.2151 46.3205 43.4413 44.0943 43.4413 41.3481C43.4413 38.6019 41.2151 36.3757 38.469 36.3757C35.7228 36.3757 33.4966 38.6019 33.4966 41.3481C33.4966 44.0943 35.7228 46.3205 38.469 46.3205ZM38.469 47.4255C41.8254 47.4255 44.5463 44.7045 44.5463 41.3481C44.5463 37.9917 41.8254 35.2708 38.469 35.2708C35.1125 35.2708 32.3916 37.9917 32.3916 41.3481C32.3916 44.7045 35.1125 47.4255 38.469 47.4255Z",
    fill: "#2E61D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.507 41.3481C41.507 43.0263 40.1466 44.3868 38.4684 44.3868C36.7901 44.3868 35.4297 43.0263 35.4297 41.3481C35.4297 39.6699 36.7901 38.3094 38.4684 38.3094C40.1466 38.3094 41.507 39.6699 41.507 41.3481Z",
    fill: "#0C4777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4687 40.7958C38.4687 41.406 37.974 41.9007 37.3638 41.9007C36.7535 41.9007 36.2588 41.406 36.2588 40.7958C36.2588 40.1855 36.7535 39.6908 37.3638 39.6908C37.974 39.6908 38.4687 40.1855 38.4687 40.7958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3305 41.3481C63.3305 44.7045 60.6096 47.4255 57.2531 47.4255C53.8967 47.4255 51.1758 44.7045 51.1758 41.3481C51.1758 37.9917 53.8967 35.2708 57.2531 35.2708C60.6096 35.2708 63.3305 37.9917 63.3305 41.3481Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.2531 46.3205C59.9993 46.3205 62.2255 44.0943 62.2255 41.3481C62.2255 38.6019 59.9993 36.3757 57.2531 36.3757C54.507 36.3757 52.2808 38.6019 52.2808 41.3481C52.2808 44.0943 54.507 46.3205 57.2531 46.3205ZM57.2531 47.4255C60.6096 47.4255 63.3305 44.7045 63.3305 41.3481C63.3305 37.9917 60.6096 35.2708 57.2531 35.2708C53.8967 35.2708 51.1758 37.9917 51.1758 41.3481C51.1758 44.7045 53.8967 47.4255 57.2531 47.4255Z",
    fill: "#2E61D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2912 41.3481C60.2912 43.0263 58.9308 44.3868 57.2525 44.3868C55.5743 44.3868 54.2139 43.0263 54.2139 41.3481C54.2139 39.6699 55.5743 38.3094 57.2525 38.3094C58.9308 38.3094 60.2912 39.6699 60.2912 41.3481Z",
    fill: "#0C4777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2529 40.7958C57.2529 41.406 56.7582 41.9007 56.1479 41.9007C55.5377 41.9007 55.043 41.406 55.043 40.7958C55.043 40.1855 55.5377 39.6908 56.1479 39.6908C56.7582 39.6908 57.2529 40.1855 57.2529 40.7958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3598 50.5258C42.6309 50.3858 42.9642 50.4922 43.1041 50.7633C45.1021 54.6345 50.7574 54.6622 52.9022 50.7511C53.0489 50.4835 53.3847 50.3856 53.6523 50.5323C53.9198 50.679 54.0178 51.0148 53.8711 51.2824C51.3198 55.9347 44.5441 55.9625 42.1222 51.2701C41.9823 50.999 42.0886 50.6657 42.3598 50.5258Z",
    fill: "#2E61D6"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 1,
    width: 78,
    height: 78,
    rx: 39,
    stroke: "#2E61D6",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_148_13775",
    x: -7,
    y: 0,
    width: 110.001,
    height: 106.685,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.180392 0 0 0 0 0.380392 0 0 0 0 0.839216 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_148_13775"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_148_13775",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_148_13775",
    x: 23,
    y: 40.7957,
    width: 4.97266,
    height: 11.8784,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12.6053,
    dy: 4.727
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_148_13775"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_148_13775",
    x: 23,
    y: 40.7957,
    width: 4.97266,
    height: 11.8784,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12.6053,
    dy: 4.727
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_148_13775"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_148_13775",
    x: 42.0596,
    y: 26.9834,
    width: 12.1543,
    height: 7.18237,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12.6053,
    dy: 4.727
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_148_13775"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_148_13775",
    x: 42.0596,
    y: 26.9834,
    width: 12.1543,
    height: 7.18237,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12.6053,
    dy: 4.727
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_148_13775"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_148_13775",
    x: 43.7178,
    y: 14,
    width: 8.83984,
    height: 8.83984,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12.6053,
    dy: 4.727
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_148_13775"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_148_13775",
    x: 43.7178,
    y: 14,
    width: 8.83984,
    height: 8.83984,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12.6053,
    dy: 4.727
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_148_13775"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_148_13775",
    x: 25.4863,
    y: 30.8508,
    width: 45.0273,
    height: 29.8342,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12.6053,
    dy: 4.727
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_148_13775"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBot);
export default __webpack_public_path__ + "static/media/chat-bot.fffe0cc0c661daee532d99abd3b42135.svg";
export { ForwardRef as ReactComponent };